import React, {Component} from "react"
import PropTypes from "prop-types"

import CompanyValuePicker from "@irati-web/companyvalues/src/components/Picker"

import {currentWordStartsWith, EmojiSearchPicker} from "."

import {COMPANY_VALUE_FIRST_CHAR, COMPANY_VALUE, EMOJI, EMOJI_FIRST_CHAR} from "./constants"

class TextReplace extends Component {
  static propTypes = {
    cursorPosition: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    showFullEmojiPicker: PropTypes.bool.isRequired,
    type: PropTypes.oneOf([COMPANY_VALUE, EMOJI]).isRequired,
    value: PropTypes.string.isRequired
  }

  getFirstCharSelector = () => {
    const {type} = this.props

    if (type === COMPANY_VALUE) {
      return COMPANY_VALUE_FIRST_CHAR
    }
    return EMOJI_FIRST_CHAR
  }

  addToValue = (newStringValue) => {
    const {onChange, value} = this.props

    const {endOfWordCursorPosition, startOfWordCursorPosition, stringToAppend} = newStringValue
    const preCursorText = value.substring(0, startOfWordCursorPosition)
    const postCursorText = value.substring(endOfWordCursorPosition, value.length)

    onChange({
      target: {
        value: `${preCursorText}${stringToAppend}${postCursorText} `
      }
    })
  }

  render() {
    const {cursorPosition, showFullEmojiPicker, type, value} = this.props

    if (showFullEmojiPicker) {
      return null
    }

    const stringToReplace = currentWordStartsWith({
      cursorPosition,
      firstChar: this.getFirstCharSelector(),
      phrase: value
    })

    if (!stringToReplace) {
      return null
    }

    if (type === COMPANY_VALUE) {
      return <CompanyValuePicker onSelect={(tag) => this.addToValue(tag)} stringToReplace={stringToReplace} />
    }

    if (type === EMOJI) {
      return <EmojiSearchPicker onSelect={(res) => this.addToValue(res)} stringToReplace={stringToReplace} />
    }

    return null
  }
}

export default TextReplace
